// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1z6Ii","filesListContainer":"PosDisputesFiles_filesListContainer__xCOfk","filesButton":"PosDisputesFiles_filesButton__162hJ"};